import { FC } from 'react';
import { DateBox } from 'devextreme-react';
import { useDate } from 'hooks';
import { IDateBoxOptions } from 'devextreme-react/date-box';

import styles from './date-range.module.scss';

interface FormProps extends IDateBoxOptions {
  caption?: string;
  startValue: string;
  minStartValue?: string;
  endValue:string,
  onRangeChanged:(reange:{start:string, end:string})=>void;
  width?:string|number
}
export const DateRange:FC<FormProps> = ({
  startValue, endValue, onRangeChanged, width, caption, minStartValue, ...props
}) => {
  const { formatDate } = useDate();

  const handleStartDateChange = (value: Date | string | number) => {
    onRangeChanged({
      start: formatDate(value),
      end: endValue,
    });
  };

  const handleEndDateChange = (value: Date | string | number) => {
    onRangeChanged({
      start: startValue,
      end: formatDate(value),
    });
  };

  return (
    <div className={styles.container} style={{ width }}>
      {caption && <div className={styles.delimiter}>{caption}</div>}

      <DateBox
        {...props}
        value={startValue}
        onValueChanged={({ value }) => handleStartDateChange(value)}
        min={minStartValue}
        max={endValue}
        width='100%'
      />

      <div className={styles.delimiter}>по</div>

      <DateBox
        {...props}
        value={endValue}
        onValueChanged={({ value }) => handleEndDateChange(value)}
        min={startValue}
        width='100%'
      />
    </div>
  );
};

